"use strict";
const readButton = (notification) => notification.querySelector("[data-notification-read]");
const markAsRead = (notification) => {
  var _a, _b;
  const url = (_a = readButton(notification)) == null ? void 0 : _a.getAttribute("href");
  if (!url || notification.dataset.focasosRead) {
    return Promise.resolve();
  }
  notification.dataset.focasosRead = "true";
  const token = (_b = document.querySelector("meta[name='csrf-token']")) == null ? void 0 : _b.content;
  return fetch(url, {
    method: "DELETE",
    headers: { "X-CSRF-Token": token, "X-Requested-With": "XMLHttpRequest", Accept: "text/javascript, */*;q=0.1" },
    credentials: "same-origin",
    keepalive: true
  }).catch(() => {
  });
};
const fadeOut = (notification) => {
  notification.addEventListener("transitionend", () => notification.remove(), { once: true });
  notification.style.opacity = 0;
};
const handle = (event) => {
  var _a, _b;
  const link = (_b = (_a = event.target).closest) == null ? void 0 : _b.call(_a, "a[href]");
  const notification = link == null ? void 0 : link.closest("[data-notification]");
  if (!link || !notification || link.matches("[data-notification-read]") || link.getAttribute("href").startsWith("#")) {
    return;
  }
  const newTab = event.type === "auxclick" || event.ctrlKey || event.metaKey || event.shiftKey || link.target === "_blank";
  if (newTab) {
    markAsRead(notification).then(() => fadeOut(notification));
    return;
  }
  event.preventDefault();
  const timeout = new Promise((resolve) => setTimeout(resolve, 1500));
  Promise.race([markAsRead(notification), timeout]).then(() => window.location.assign(link.href));
};
document.addEventListener("click", handle, true);
document.addEventListener("auxclick", handle, true);
